import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import theme from './theme'

/** テーマ適用プラグイン */
export const wrapRootElement = ({ element }: any) => {
  return <ThemeProvider theme={theme}>{element}</ThemeProvider>
}
